<p-dialog [modal]="true" [(visible)]="visible" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    [style]="{ width: '30vw' }" [draggable]="false" [resizable]="false">
    <ng-template pTemplate="headless">
        <div class="p-4 flex flex-col gap-5 bg-[#FFFFFF] rounded-[16px] font-[Gilroy]">
            <div class="flex w-full gap-4 mobile:gap-1 justify-between items-center">
                <p class="text-black font-semibold text-2xl mobile:text-md">
                    {{ 'locations.add_new_location_title' | transloco }}
                </p>
                <button (click)="closeModal(false)" title="{{ 'shared.close' | transloco }}">
                    <img src="assets/icons/close-circle-black.svg" alt="X" />
                </button>
            </div>

            <p class="text-neutral-800">
                {{ 'locations.add_new_location_description' | transloco }}
            </p>

            <div class="bg-neutral-100 rounded-[16px] p-4 text-neutral-800 text-sm font-medium">
                <p>
                    {{ 'locations.additional_location_info' | transloco }}
                </p>
                <p class="text-lg font-bold mt-1">
                    {{ 'locations.additional_location_price' | transloco }}
                </p>
            </div>

            <div class="flex desktop:flex-wrap mobile:flex-col gap-3 w-full">
                <div class="desktop:flex-[1] mobile:w-full h-[50px]">
                    <app-custom-button buttonText="{{ 'locations.confirm_location_button' | transloco }}"
                        [isDisabled]="false" backgroundColor="bg-primary" textColor="text-white" fontWeight="font-bold"
                        borderColor="border-primary" hoverBackgroundColor="hover:bg-primary-1200"
                        hoverBorderColor="hover:border-primary-1200" (click)="confirmAddLocation()"></app-custom-button>
                </div>
                <div class="desktop:flex-[1] mobile:w-full h-[50px]">
                    <app-custom-button buttonText="{{ 'locations.cancel_button' | transloco }}" [isDisabled]="false"
                        backgroundColor="bg-white" textColor="text-neutral-800" fontWeight="font-medium"
                        hoverTextColor="hover:text-black" borderColor="border-neutral-400"
                        hoverBackgroundColor="hover:bg-neutral-200" hoverBorderColor="hover:border-neutral-200"
                        (click)="closeModal(false)"></app-custom-button>
                </div>
            </div>
        </div>

    </ng-template></p-dialog>